<template>
    <user_subscribe
        :only_view=true
        v-model="selected_cats"
        :selected="selected_cats">
    </user_subscribe>
</template>

<script>
import user_subscribe from "../../../../../contragent/user/subscribe/user_subscribe.vue";

export default {
    name: "cont_subscribes",
    components: {user_subscribe},
    
    props : {
        contragent : {
            type : Object,
            required : true,
        }
    },
    
    computed : {
        selected_cats() {
            return this.contragent.subscribes.map(id => {
                return id;
            });
        }
    }

}
</script>


<style scoped>

</style>